/**
 * Launch facts, in one place so no page can drift from another. Every value
 * here was read off the Pons v2 create form with ETH selected on 2026-09-04.
 *
 * Fees are not here. The creator tax is chosen at launch and is immutable, so
 * every fee sentence is derived from the server in ./fees.ts.
 */

/** Used until GET /api/config resolves. The pair is fixed for the launch. */
export const PAIR_FALLBACK = "ETH";

/** Paid once, by the creator, to create the token on Pons v2. */
export const LAUNCH_FEE = "0.0005 ETH";

/** The bonding curve graduates once it has raised this much. */
export const GRADUATION = "4.2 ETH";

/** Shown when the server has not published a pledge string yet. */
export const PLEDGE_FALLBACK = "50% of the creator's share of trading fees";

/** Solana mint of $INDEXSY. Two impostor tokens share the ticker. */
export const INDEXSY_MINT = "9WeQ4526GbxDgFu8PPHWm1zfX4ie5xKjwyBsk1RMpump";

/** What a claim costs the holder in gas on Robinhood Chain. */
export const CLAIM_GAS = "about $0.10";

/** Used until the server publishes the same sentence. */
export const PROMOTION_FALLBACK =
  "We pay nobody to promote $TISM and give no tokens for posts.";

/** Stands in for the charity name while the name is withheld. */
export const CHARITY_PLACEHOLDER = "a Vancouver autism charity";

/** Shown for a disclosure the team cannot fill in before the launch. */
export const AT_LAUNCH = "published at launch";
